import React, { useState, useRef, useEffect } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import swal from "sweetalert";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";

// const defaultSrc =
//     "https://raw.githubusercontent.com/roadmanfong/react-cropper/master/example/img/child.jpg";

export const Demo = ({ imageBlob, handleImgCrop }) => {
    const dispatch = useDispatch();
    const [image, setImage] = useState(null);
    const [cropData, setCropData] = useState("#");
    const cropperRef = useRef(null);
    const [width, setWidth] = useState(null);
    const [height, setHeight] = useState(null);
    const [files, setFiles] = useState(null);
    const [isMetRequirement, setRequirement] = useState(null);

    useEffect(() => {
        if (imageBlob) {
            setFiles(imageBlob)
            onChange(imageBlob)
        }
    });
    const onChange = (e) => {
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };
        reader.readAsDataURL(e);
    };

    const getCropData = async () => {
        dispatch(showLoader());
        if (typeof cropperRef.current?.cropper !== "undefined") {
            let DataUrl = cropperRef.current?.cropper.getCroppedCanvas();
            let _this = this;
            var imgwidth = 0;
            var imgheight = 0;
            var minwidth = 480;
            var minheight = 640;
            var maxwidth = 720;
            var maxheight = 1280;
            // var minwidth = 1000;
            // var minheight = 2000;
            // var maxwidth = 3050;
            // var maxheight = 3200;
            imgwidth = DataUrl.width;
            imgheight = DataUrl.height;
            if ((minwidth <= imgwidth && minheight <= imgheight) && (maxwidth >= imgwidth && maxheight >= imgheight)) {
                handleImgCrop(DataUrl.toDataURL())
                setCropData(DataUrl.toDataURL());
            } else {
                dispatch(hideLoader());
                swal("Error!", "Select image with minimum dimension of 480*640 and maximum dimension of 720*1280", "warning");
                // swal("Error!", "Select image with minimum dimension of 1000*2000 and maximum dimension of 3050*3200", "warning");
            }
        }

    };

    const showHeightWidth = () => {
        let Data = cropperRef.current?.cropper.getCroppedCanvas()
        const dataHeight = Data.height;
        const dataWidth = Data.width;
        setHeight(dataHeight);
        setWidth(dataWidth);
        const imgwidth = 0;
        const imgheight = 0;
        const minwidth = 480;
        const minheight = 640;
        const maxwidth = 720;
        const maxheight = 1280;
        // const minwidth = 1000;
        // const minheight = 2000;
        // const maxwidth = 3050;
        // const maxheight = 3200;
        if ((minwidth <= dataWidth && minheight <= dataHeight) && (maxwidth >= dataWidth && maxheight >= dataHeight)) {
            setRequirement(true)
        } else {
            setRequirement(false)
        }
    }

    return (
        files &&
        <div>
            <div style={{ width: "100%" }}>
                <Cropper
                    style={{ height: 350, width: "100%" }}
                    initialAspectRatio={1}
                    // aspectRatio={1/1}
                    preview=".img-preview"
                    src={image}
                    ref={cropperRef}
                    viewMode={1}
                    guides={true}
                    crop={showHeightWidth}
                    minCropBoxHeight={10}
                    minCropBoxWidth={10}
                    background={false}
                    responsive={true}
                    checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                />
            </div>
            <div>
                <span className="text-14-normal">Current width and height is {width}x{height}</span>
                {/* <span className="text-14-normal">Current width : </span>
                <sapn className="text-14-normal me-1">{width}</sapn>
                <span className="text-14-normal ml-75"> Current height : </span> */}
                {/* <sapn className="text-14-normal">{height}</sapn> */}
                <div className="row mt-1 pb-0 mb-1">
                    <div className="col-12">
                        <span className="text-14-normal">Required width and height is minimum 480x640 and maximum 720x1280</span>
                    </div>
                </div>
                <span className={isMetRequirement ? "color-green" : "color-red"}>{isMetRequirement ? "This current size is matching with required size." : "This current width and height not matching with required size."}</span>
                <div
                    className="box"
                    style={{ width: "50%", float: "right", height: "auto" }}
                >
                    <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        style={{ float: "right" }}
                        onClick={getCropData}
                    >
                        Upload
                    </button>
                </div>
            </div>
            <br style={{ clear: "both" }} />
        </div>
    );
};

export default Demo;
